import { IFilterComplete } from "../../filter-complete/filter-complete";
import { Plan } from "./plan";

export class Entity implements IFilterComplete {
  public Name: string;
  public Code: string;
  public Id: number;
  public ValideOnlinePreAdmision: boolean;
  public TokenRequired: boolean;
  public CredentialRequired: boolean;
  public PreAuthorizationInReservation: boolean;
  public AthorizationValidity: boolean;
  public MedicalOrderValidity: boolean;
  public AthorizationValidityDay?: number;
  public MedicalOrderValidityDay?: number;
  public RequiredDiagnosis: boolean;
  public DiagnosisCodeMode: string;
  public Plans: Plan[];
  public ShowValidation: boolean;
  public ProceduresGroupedRequired: boolean;
}
